import { IFieldSubmissionMap, IFormFieldSubmission } from "@common/redux/formSubmission/interface";
import { DATE_ALLOWED, DATE_NOT_ALLOWED, FieldRulesDetails, IFieldRuleConfig, MAX_DATE, MIN_DATE, WEEKEND_NOT_ALLOWED } from "@presentation/FormBuilder/Rules/config";
import { validateSubRule } from "@presentation/FormBuilder/utils";
import { FieldProps } from "../../FormFieldSelector/interfaces";


export const getInitialRuleConfigDatePicker = (
  rule: string
): IFieldRuleConfig => {
  const ruleDetails = FieldRulesDetails[rule];

  switch (rule) {
    case MAX_DATE:
    case MIN_DATE:
    case DATE_ALLOWED:
    case DATE_NOT_ALLOWED:

      return {
        rule,
        value: "",
        errorMessage: ruleDetails.defaultErrorMessage || "",
      };
    case WEEKEND_NOT_ALLOWED:
      return {
        rule,
        value: undefined,
        errorMessage: ruleDetails.defaultErrorMessage || "",
      };
    default:
      return {
        rule,
        value: "",
        errorMessage: "",
      } as IFieldRuleConfig;
  }
};


export const validateDateFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission,
  fieldSubmissionMap: IFieldSubmissionMap
): [boolean, string] => {
  const { isRequired, rules: fieldRules, isVisible } = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;
  const submissionValue = (fieldSubmissionValue && fieldSubmissionValue?.value) || "";

  if (isRequired && !!isVisible) {
    if (!submissionValue) {
      return [false, "This is a Required Field"];
    }
  }
  if (fieldRules) {
    for (let i = 0; i < fieldRules.length; i++) {
      const [isValidated, validatationErrorMessage] = validationRule(
        fieldRules[i],
        submissionValue,
        fieldSubmissionMap
      );

      if (!isValidated && validatationErrorMessage != "") {
        return [isValidated, validatationErrorMessage];
      }
    }
  }

  return [true, ""];
};

export const validationRule = (fieldRule: IFieldRuleConfig, submissionValue: any, fieldSubmissionMap: IFieldSubmissionMap): [boolean, string] => {
  const { rule, value, errorMessage, subRules } = fieldRule;
  const ruleType: string = rule;
  const ruleValue: any = value;
  const ruleErrorValue: string = errorMessage;
  const ruleDate = ruleValue?.split("T");
  const submissionDate = submissionValue.split("T");
  switch (ruleType) {

    case "MAX_DATE":
      if (ruleDate[0] < submissionDate[0])
        return [false, ruleErrorValue];
      break;
    case "MIN_DATE":
      if (ruleDate[0] > submissionDate[0])
        return [false, ruleErrorValue];
      break;
    case "DATE_ALLOWED":
      if (ruleDate[0] != submissionDate[0])
        return [false, ruleErrorValue];
      break;
    case "DATE_NOT_ALLOWED":
      if (ruleDate[0] == submissionDate[0])
        return [false, ruleErrorValue];
      break;
    case "WEEKEND_NOT_ALLOWED":
      const changedSubmissionDate = submissionDate[0];
      const changedDate = new Date(changedSubmissionDate);
      const day = changedDate.getDay();
      if (day === 6 || day === 0)
        return [false, ruleErrorValue];
      break;
    default:
      break;
  }

  if (subRules?.length > 0) {
    const [isValidated, validatationErrorMessage] = validateSubRule(fieldRule, submissionValue, fieldSubmissionMap, validationRule);
    return [isValidated, validatationErrorMessage];
  }

  return [true, ""];
};
